var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCapsule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1091_713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1199 13.3919L15.5005 18.6694L16.6313 20.0878L23.2507 14.8102L22.1199 13.3919Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9055 13.4909L14.9764 21.4072L16.1073 22.8256L26.0363 14.9092L24.9055 13.4909Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6912 13.5896L14.4524 24.1448L15.5832 25.5631L28.822 15.008L27.6912 13.5896Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4768 13.6886L13.9283 26.8826L15.0592 28.3009L31.6076 15.107L30.4768 13.6886Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2625 13.7876L13.4043 29.6204L14.5351 31.0387L34.3933 15.206L33.2625 13.7876Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3933 15.2058L14.5352 31.0386L15.666 32.4569L35.5241 16.6242L34.3933 15.2058Z",
    fill: "#4169E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.179 15.3049L14.0111 33.7764L15.1419 35.1947L38.3098 16.7232L37.179 15.3049Z",
    fill: "#4169E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3098 16.7231L15.142 35.1946L17.4036 38.0312L40.5715 19.5597L38.3098 16.7231Z",
    fill: "#4169E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5714 19.5597L17.4036 38.0312L18.5344 39.4496L41.7022 20.9781L40.5714 19.5597Z",
    fill: "#5577E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4169 20.1867L17.7621 21.5061L18.8929 22.9244L20.5478 21.605L19.4169 20.1867Z",
    fill: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5477 21.6049L17.238 24.2437L18.3689 25.662L21.6786 23.0232L20.5477 21.6049Z",
    fill: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6785 23.0233L16.714 26.9814L17.8448 28.3998L22.8094 24.4416L21.6785 23.0233Z",
    fill: "#7A9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8093 24.4417L16.1899 29.7192L17.3208 31.1376L23.9402 25.86L22.8093 24.4417Z",
    fill: "#8AABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.595 24.5405L17.3208 31.1375L18.4516 32.5558L26.7259 25.9588L25.595 24.5405Z",
    fill: "#9ABBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3934 15.2059L29.4288 19.1641L30.5597 20.5824L35.5242 16.6242L34.3934 15.2059Z",
    fill: "#2040A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.179 15.3048L32.2145 19.2629L33.3453 20.6813L38.3098 16.7231L37.179 15.3048Z",
    fill: "#2040A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3098 16.723L35.0001 19.3618L37.2618 22.1985L40.5715 19.5597L38.3098 16.723Z",
    fill: "#1A3590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7023 20.9782L18.5344 39.4497L19.6652 40.868L42.8331 22.3965L41.7023 20.9782Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0475 22.2976L20.1893 38.1304L21.3202 39.5487L41.1783 23.716L40.0475 22.2976Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3926 23.6171L21.8441 36.811L22.9749 38.2294L39.5234 25.0354L38.3926 23.6171Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.833 22.3964L19.6652 40.8679L20.796 42.2862L43.9638 23.8147L42.833 22.3964Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9639 23.8146L20.796 42.2861L23.0577 45.1228L46.2255 26.6513L43.9639 23.8146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2255 26.6513L23.0576 45.1228L24.1884 46.5411L47.3563 28.0696L46.2255 26.6513Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7014 29.3892L25.8433 45.2219L26.9741 46.6403L46.8323 30.8075L45.7014 29.3892Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1774 32.1269L28.6289 45.3208L29.7597 46.7391L46.3082 33.5452L45.1774 32.1269Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6535 34.8645L31.4147 45.4197L32.5455 46.838L45.7843 36.2829L44.6535 34.8645Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1294 37.6022L34.2003 45.5186L35.3311 46.9369L45.2602 39.0205L44.1294 37.6022Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6054 40.3401L36.986 45.6177L38.1168 47.036L44.7362 41.7584L43.6054 40.3401Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3799 33.0505L24.1057 39.6475L25.2365 41.0658L33.5108 34.4688L32.3799 33.0505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1655 33.1493L25.2365 41.0657L26.3673 42.484L36.2964 34.5676L35.1655 33.1493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2965 34.5678L28.0222 41.1648L29.153 42.5831L37.4273 35.9862L36.2965 34.5678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9638 23.8148L38.9993 27.7729L41.2609 30.6096L46.2255 26.6514L43.9638 23.8148Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2255 26.6515L42.9158 29.2903L44.0466 30.7086L47.3563 28.0698L46.2255 26.6515Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7015 29.3892L40.7369 33.3474L41.8678 34.7657L46.8323 30.8076L45.7015 29.3892Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1774 32.1268L40.2129 36.085L41.3437 37.5033L46.3083 33.5451L45.1774 32.1268Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M19.4997 27.0805L17.8448 28.3999L18.9757 29.8182L20.6305 28.4988L19.4997 27.0805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.2853 27.1794L20.6305 28.4988L21.7613 29.9171L23.4162 28.5977L22.2853 27.1794Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1091_713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3288,
    height: 45.3487,
    fill: "white",
    transform: "translate(0 26.3879) rotate(-38.565)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCapsule);
export default __webpack_public_path__ + "static/media/blue-capsule.c721d117f8e2c98c7bfa8090ba3980e5.svg";
export { ForwardRef as ReactComponent };